import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-428328a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = { class: "text-xl md:text-xl font-bold" }
const _hoisted_4 = { class: "content h-full max-h-full" }
const _hoisted_5 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemein", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-6",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Seilzug von/nach Mast:", -1))
const _hoisted_10 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Abspannabschnittlänge:", -1))
const _hoisted_12 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Seilzugfläche Erfordernisse:", -1))
const _hoisted_14 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Seilzugfläche", -1))
const _hoisted_17 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte (Seilzugfläche)", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Soll-Entfernung zum Mastmittelpunkt:", -1))
const _hoisted_24 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ist-Entfernung zum Mastmittelpunkt:", -1))
const _hoisted_26 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Nutzungsarten der Fläche:", -1))
const _hoisted_28 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_29 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_30 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_31 = { class: "text-xs col-span-4 text-gray-500" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyse ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-6",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyseergebnisse", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs col-span-2" }, "Betroffene Flurstücke:", -1))
const _hoisted_35 = { class: "text-xs text-gray-500 col-span-6 grid grid-cols-3" }
const _hoisted_36 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_37 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_38 = { class: "h-full max-h-full" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit (Seilzugfläche) 1/2", -1))
const _hoisted_40 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_45 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_46 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_47 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_48 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_49 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_50 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_51 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_52 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_53 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_54 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_55 = { class: "h-full max-h-full" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit (Seilzugfläche) 2/2", -1))
const _hoisted_57 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_62 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_63 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_64 = { class: "text-xs text-gray-500 col-span-1" }
const _hoisted_65 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_66 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_67 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_68 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_69 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_70 = { class: "h-full max-h-full" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Ökologie (Seilzugfläche)", -1))
const _hoisted_72 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-5",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ampelkarte", -1))
const _hoisted_77 = { class: "col-span-5 text-xs" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "FFH-Gebiet", -1))
const _hoisted_79 = { class: "col-span-5 text-xs" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Biotop", -1))
const _hoisted_81 = { class: "col-span-5 text-xs" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Vogelschutzgebiet", -1))
const _hoisted_83 = { class: "col-span-5 text-xs" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Wasserschutzgebiet", -1))
const _hoisted_85 = { class: "col-span-5 text-xs" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Sonstiges", -1))
const _hoisted_87 = { class: "col-span-5 text-xs" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Allgemeine Bilder Seilzugfläche", -1))
const _hoisted_90 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-8 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, null, -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_93 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_94 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Zuwegung Seilzugfläche ", -1))
const _hoisted_96 = { class: "content h-full max-h-full" }
const _hoisted_97 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte (Zuwegung)", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_103 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_104 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_105 = { class: "text-xs col-span-4 text-gray-500" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyse ", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-6",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyseergebnisse", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs col-span-2" }, "Betroffene Flurstücke:", -1))
const _hoisted_109 = { class: "text-xs text-gray-500 col-span-6 grid grid-cols-3" }
const _hoisted_110 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_111 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_112 = { class: "h-full max-h-full" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Geländebeschaffenheit (Zuwegung)", -1))
const _hoisted_114 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_119 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_120 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_121 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_122 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_123 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_124 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_125 = { class: "h-full max-h-full" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Grabenquerungen", -1))
const _hoisted_127 = { key: 0 }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-span-3 text-sm font-bold",
    style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
  }, " Anzahl "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-sm font-bold col-span-4",
    style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
  }, " Beschreibung/Eingabewerte "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-span- text-sm font-bold",
    style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
  }, " Bewertung ")
], -1))
const _hoisted_129 = { class: "text-xs col-span-3" }
const _hoisted_130 = { class: "text-xs text-gray-500 col-span-4" }
const _hoisted_131 = { class: "justify-self-end row-span-2" }
const _hoisted_132 = { key: 1 }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "justify-center items-center col-span-8",
    style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                    rgb(235, 239, 240) rgb(235, 239, 240)","border-radius":"5px"}
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, " Keine Grabenquerungen aufgenommen ")
  ])
], -1))
const _hoisted_134 = [
  _hoisted_133
]
const _hoisted_135 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_136 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_137 = { class: "h-full max-h-full" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Ökologie (Zuwegung)", -1))
const _hoisted_139 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-5",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ampelkarte", -1))
const _hoisted_144 = { class: "col-span-5 text-xs" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "FFH-Gebiet", -1))
const _hoisted_146 = { class: "col-span-5 text-xs" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Biotop", -1))
const _hoisted_148 = { class: "col-span-5 text-xs" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Vogelschutzgebiet", -1))
const _hoisted_150 = { class: "col-span-5 text-xs" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Wasserschutzgebiet", -1))
const _hoisted_152 = { class: "col-span-5 text-xs" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Sonstiges", -1))
const _hoisted_154 = { class: "col-span-5 text-xs" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Allgemeine Bilder Zuwegung", -1))
const _hoisted_157 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-8 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, null, -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_160 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_161 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Fläche zwischen Mast und Seilzugfläche", -1))
const _hoisted_163 = { class: "content h-full max-h-full" }
const _hoisted_164 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte (Fläche zwischen Mast und Seilzugfläche)", -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Nutzungsarten der Fläche:", -1))
const _hoisted_171 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_172 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_173 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_174 = { class: "text-xs col-span-4 text-gray-500" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyse ", -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-6",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyseergebnisse", -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs col-span-2" }, "Betroffene Flurstücke:", -1))
const _hoisted_178 = { class: "text-xs text-gray-500 col-span-6 grid grid-cols-3" }
const _hoisted_179 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_180 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_181 = { class: "h-full max-h-full" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit (Fläche zwischen Mast und Seilzugfläche)", -1))
const _hoisted_183 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_188 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_189 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_190 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_191 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_192 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_193 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_194 = { class: "text-xs text-gray-500 col-span-1" }
const _hoisted_195 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_196 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_197 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_198 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_199 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_200 = { class: "h-full max-h-full" }
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Ökologie (Fläche zwischen Mast und Seilzugfläche)", -1))
const _hoisted_202 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-5",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ampelkarte", -1))
const _hoisted_207 = { class: "col-span-5 text-xs" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "FFH-Gebiet", -1))
const _hoisted_209 = { class: "col-span-5 text-xs" }
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Biotop", -1))
const _hoisted_211 = { class: "col-span-5 text-xs" }
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Vogelschutzgebiet", -1))
const _hoisted_213 = { class: "col-span-5 text-xs" }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Wasserschutzgebiet", -1))
const _hoisted_215 = { class: "col-span-5 text-xs" }
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Sonstiges", -1))
const _hoisted_217 = { class: "col-span-5 text-xs" }
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Allgemeine Bilder Fläche zwischen Mast und Seilzugfläche", -1))
const _hoisted_220 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-8 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, null, -1))
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_223 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_224 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_225 = { class: "text-xl md:text-xl font-bold" }
const _hoisted_226 = { class: "content h-full max-h-full" }
const _hoisted_227 = { class: "text-l md:text-l font-bold" }
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_is_vorhanden_char_and_label = _resolveComponent("is-vorhanden-char-and-label")!
  const _component_bewertung_chip = _resolveComponent("bewertung-chip")!
  const _component_Seilzugflaechen_footer = _resolveComponent("Seilzugflaechen-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!
  const _component_oneto_five_image_div_mehrfach = _resolveComponent("oneto-five-image-div-mehrfach")!
  const _component_pdf_a_4_page = _resolveComponent("pdf-a-4-page")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_oneto_five_image_div = _resolveComponent("oneto-five-image-div")!
  const _component_UniversalPdfImageRow = _resolveComponent("UniversalPdfImageRow")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSeilzugflaechen(_ctx.ba), (seilzugflaeche, szfKey) => {
    return (_openBlock(), _createElementBlock("span", { key: szfKey }, [
      _createVNode(_component_pdf_a4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang,
        class: "pdf-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_3, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " (" + _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.typ')?.getSelectedAuswahlLabelsString()) + ")", 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'allgemein-modal.allgemein-group.seilzugvonmast')['eingabeText']), 1),
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'allgemein-modal.allgemein-group.abspannabschnittlaenge')['eingabeText']), 1),
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'allgemein-modal.allgemein-group.erfordnerisse')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "allgemein-modal.allgemein-group.flaeche-vorhanden",
                    label: "Fläche zwischen Mast und Seilzugfläche vorhanden",
                    class: "col-span-8"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "allgemein-modal.allgemein-group.flaeche-notwendig",
                    label: "Fläche zwischen Mast und Seilzugfläche notwendig",
                    class: "col-span-8"
                  }, null, 8, ["fragenblock", "ba"])
                ]),
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.entfernung-mast-soll')['eingabeText']), 1),
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.entfernung-mast-ist')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.allgemein.entfernung-mast-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seilzugflaeche.findFrageByRelativePath(_ctx.ba,
                  'seilzugflaeche-modal.allgemein.nutzungsart-der-flaeche'
                )['eingabeMehrfachAuswahlWerts'], (v, key) => {
                      return (_openBlock(), _createElementBlock("ul", {
                        key: key,
                        class: ""
                      }, [
                        (_openBlock(), _createElementBlock("li", {
                          key: key,
                          class: "text-xs text-gray-500"
                        }, _toDisplayString(v), 1))
                      ]))
                    }), 128))
                  ]),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.allgemein.nutzungsart-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.allgemein.fremdobjekte-vorhanden",
                    label: "Fremdobjekte auf Fläche",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche')['eingabeText']), 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.allgemein.sonstiges-vorhanden",
                    label: "Sonstiges",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.sonstiges-beschreibung')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.allgemein.sonstiges-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end col-span-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_32,
                  _hoisted_33,
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.betroffeneflurstuecke').getCurrentInput()?.split(';')?.sort(), (v, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "text-xs text-gray-500"
                      }, _toDisplayString(v), 1))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode(_component_Seilzugflaechen_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: ""
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang,
        class: "pdf-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _hoisted_42,
                  _hoisted_43,
                  _hoisted_44,
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.gefaelle-group.gefaelle-vorhanden",
                    label: "Gefälle/Hang/Böschung",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seilzugflaeche.findFrageByRelativePath(_ctx.ba,
                  'seilzugflaeche-modal.gefaelle-group.gefaelle-boeschung-art'
                )['eingabeMehrfachAuswahlWerts'], (v, key) => {
                      return (_openBlock(), _createElementBlock("ul", {
                        key: key,
                        class: ""
                      }, [
                        (_openBlock(), _createElementBlock("li", {
                          key: key,
                          class: "text-xs text-gray-500"
                        }, _toDisplayString(v), 1))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_46, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.gefaelle-group.gefaelle-beschreibung')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.gefaelle-group.gefaelle-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.gefaelle-group.gefaelle-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.ausholzung-group.ausholzung-erforderlich",
                    label: "Ausholzung erforderlich",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_47, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.ausholzung-group.ausholzung-art')?.getSelectedAuswahlLabelsString()), 1),
                  _createElementVNode("div", _hoisted_48, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.ausholzung-group.ausholzung-beschreibung')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.ausholzung-group.ausholzung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.ausholzung-group.ausholzung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.rodung-group.rodung-erforderlich",
                    label: "Rodung erforderlich",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_49, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.rodung-group.rodung-anzahl-baeume')['eingabeText']), 1),
                  _createElementVNode("div", _hoisted_50, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.rodung-group.rodung-beschreibung')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.rodung-group.rodung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.rodung-group.rodung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.graben-group.graben-vorhanden",
                    label: "Graben vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_51, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.graben-group.graben-anzahl')['eingabeText']), 1),
                  _createElementVNode("div", _hoisted_52, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.graben-group.graben-beschreibung')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.graben-group.graben-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.graben-group.graben-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ])
              ]),
              _createVNode(_component_Seilzugflaechen_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: ""
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang,
        class: "pdf-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _hoisted_59,
                  _hoisted_60,
                  _hoisted_61,
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.feuchtgebiete-group.graben-vorhanden",
                    label: "Feuchtgebiete vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_62, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-beschreibung')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-vorhanden",
                    label: "Naturdenkmäler vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_63, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-beschreibung')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.kampfmittel-group.kampfmittel-vorhanden",
                    label: "Kampfmittel vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_64, [
                    (seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.kampfmittel-group.kampfmittel-freimessung')?.getCurrentInput())
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" Freimessung erforderlich ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Freimessung nicht erforderlich ")
                        ], 64))
                  ]),
                  _createElementVNode("div", _hoisted_65, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.kampfmittel-group.kampfmittel-art')['eingabeText']), 1),
                  _createElementVNode("div", _hoisted_66, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.kampfmittel-group.kampfmittel-beschreibung')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.kampfmittel-group.kampfmittel-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.kampfmittel-group.kampfmittel-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.sonstiges-group.sonstiges-vorhanden",
                    label: "Sonstiges vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_67, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.sonstiges-group.sonstiges-beschreibung')['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.sonstiges-group.sonstiges-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ])
              ]),
              _createVNode(_component_Seilzugflaechen_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: ""
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang,
        class: "pdf-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _hoisted_74,
                  _hoisted_75,
                  _hoisted_76,
                  _createElementVNode("div", _hoisted_77, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.oekologie-group.ampelkarte')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.oekologie-group.ampelkarte-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_78,
                  _createElementVNode("div", _hoisted_79, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.oekologie-group.ffh-gebiet')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.oekologie-group.ffh-gebiet-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_80,
                  _createElementVNode("div", _hoisted_81, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.oekologie-group.biotop')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.oekologie-group.biotop-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_82,
                  _createElementVNode("div", _hoisted_83, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.oekologie-group.vogelschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.oekologie-group.vogelschutzgebiet-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_84,
                  _createElementVNode("div", _hoisted_85, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.oekologie-group.wasserschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.oekologie-group.wasserschutzgebiet-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_86,
                  _createElementVNode("div", _hoisted_87, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.oekologie-group.sonstiges')?.getCurrentInput()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.oekologie-group.sonstiges-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ]),
                _hoisted_88,
                _hoisted_89,
                _createElementVNode("div", _hoisted_90, [
                  _hoisted_91,
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.bilder-group.bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ]),
                _hoisted_92
              ]),
              _createVNode(_component_Seilzugflaechen_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang,
                class: ""
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      (
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-vorhanden')?.getCurrentInput() ||
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-notwendig')?.getCurrentInput() )
        ? (_openBlock(), _createBlock(_component_pdf_a4_page, {
            key: 0,
            "no-margin": "",
            "pdf-key": _ctx.lang,
            class: "pdf-content"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("div", _hoisted_94, [
                  _createVNode(_component_tng_header, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _hoisted_95,
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _hoisted_98,
                      _hoisted_99,
                      _hoisted_100,
                      _hoisted_101,
                      _hoisted_102,
                      _createVNode(_component_is_vorhanden_char_and_label, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        fragesPath: "zuwegung-seilzugflaeche-modal.allgemein.fremdobjekte-vorhanden",
                        label: "Fremdobjekte auf Fläche",
                        class: "col-span-2"
                      }, null, 8, ["fragenblock", "ba"]),
                      _createElementVNode("div", _hoisted_103, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche')['eingabeText']), 1),
                      _createElementVNode("div", _hoisted_104, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche')['eingabeText']), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _createVNode(_component_is_vorhanden_char_and_label, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        fragesPath: "zuwegung-seilzugflaeche-modal.allgemein.sonstiges-vorhanden",
                        label: "Sonstiges",
                        class: "col-span-2"
                      }, null, 8, ["fragenblock", "ba"]),
                      _createElementVNode("div", _hoisted_105, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.allgemein.sonstiges-beschreibung')['eingabeText']), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.allgemein.sonstiges-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end col-span-2"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _hoisted_106,
                      _hoisted_107,
                      _hoisted_108,
                      _createElementVNode("div", _hoisted_109, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.allgemein.betroffeneflurstuecke').getCurrentInput()?.split(';')?.sort(), (v, key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: key,
                            class: "text-xs text-gray-500"
                          }, _toDisplayString(v), 1))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createVNode(_component_Seilzugflaechen_footer, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: ""
                  }, null, 8, ["ba", "immobilie", "lang"])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["pdf-key"]))
        : _createCommentVNode("", true),
      (
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-vorhanden')?.getCurrentInput() ||
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-notwendig')?.getCurrentInput() )
        ? (_openBlock(), _createBlock(_component_pdf_a4_page, {
            key: 1,
            "no-margin": "",
            "pdf-key": _ctx.lang,
            class: "pdf-content"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _createVNode(_component_tng_header, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createElementVNode("div", _hoisted_112, [
                    _hoisted_113,
                    _createElementVNode("div", _hoisted_114, [
                      _hoisted_115,
                      _hoisted_116,
                      _hoisted_117,
                      _hoisted_118,
                      _createVNode(_component_is_vorhanden_char_and_label, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        fragesPath: "zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-vorhanden",
                        label: "Gefälle",
                        class: "col-span-7"
                      }, null, 8, ["fragenblock", "ba"]),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _createVNode(_component_oneto_five_image_div_mehrfach, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        fragesPath: "zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-bilder",
                        lang: _ctx.lang,
                        class: "col-span-8 ml-2"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _createVNode(_component_is_vorhanden_char_and_label, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        fragesPath: "zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-erforderlich",
                        label: "Ausholzung erforderlich",
                        class: "col-span-2"
                      }, null, 8, ["fragenblock", "ba"]),
                      _createElementVNode("div", _hoisted_119, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-beschreibung')['eingabeText']), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _createVNode(_component_oneto_five_image_div_mehrfach, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        fragesPath: "zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-bilder",
                        lang: _ctx.lang,
                        class: "col-span-8 ml-2"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _createVNode(_component_is_vorhanden_char_and_label, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        fragesPath: "zuwegung-seilzugflaeche-modal.rodung-group.rodung-erforderlich",
                        label: "Rodung erforderlich",
                        class: "col-span-2"
                      }, null, 8, ["fragenblock", "ba"]),
                      _createElementVNode("div", _hoisted_120, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.rodung-group.anzahl-baeume')['eingabeText']), 1),
                      _createElementVNode("div", _hoisted_121, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.rodung-group.rodung-beschreibung')['eingabeText']), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.rodung-group.rodung-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _createVNode(_component_oneto_five_image_div_mehrfach, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        fragesPath: "zuwegung-seilzugflaeche-modal.rodung-group.rodung-bilder",
                        lang: _ctx.lang,
                        class: "col-span-8 ml-2"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _createVNode(_component_is_vorhanden_char_and_label, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        fragesPath: "seilzugflaeche-modal.sonstiges-group.sonstiges-vorhanden",
                        label: "Sonstiges vorhanden",
                        class: "col-span-2"
                      }, null, 8, ["fragenblock", "ba"]),
                      _createElementVNode("div", _hoisted_122, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.sonstiges-group.sonstiges-beschreibung')['eingabeText']), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "seilzugflaeche-modal.sonstiges-group.sonstiges-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                    ])
                  ]),
                  _createVNode(_component_Seilzugflaechen_footer, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: ""
                  }, null, 8, ["ba", "immobilie", "lang"])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["pdf-key"]))
        : _createCommentVNode("", true),
      (_ctx.getGrabenquerungen(_ctx.ba,seilzugflaeche).length > 0)
        ? (_openBlock(), _createBlock(_component_pdf_a_4_page, {
            key: 2,
            "no-margin": "",
            "pdf-key": _ctx.lang,
            class: "pdf-content"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_123, [
                _createElementVNode("div", _hoisted_124, [
                  _createVNode(_component_tng_header, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createElementVNode("div", _hoisted_125, [
                    _hoisted_126,
                    (_ctx.getGrabenquerungen(_ctx.ba,seilzugflaeche).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                          _hoisted_128,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGrabenquerungen(_ctx.ba,seilzugflaeche), (grabenquerung, key) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: key,
                              class: "ml-2 grid grid-cols-8 justify-items-stretch items-center",
                              style: {"border-style":"solid","border-color":"white white white rgb(216, 215, 26)","border-radius":"5px"}
                            }, [
                              _createElementVNode("div", _hoisted_129, _toDisplayString(grabenquerung['graben-anzahl']), 1),
                              _createElementVNode("div", _hoisted_130, _toDisplayString(grabenquerung['graben-beschreibung']), 1),
                              _createElementVNode("div", _hoisted_131, [
                                ('plus' === grabenquerung['graben-bewertung'])
                                  ? (_openBlock(), _createBlock(_component_PdfChip, {
                                      key: 0,
                                      color: "green",
                                      "mangel-amount-mode": "",
                                      value: "1",
                                      "pdf-mode": ""
                                    }))
                                  : _createCommentVNode("", true),
                                ('o' === grabenquerung['graben-bewertung'])
                                  ? (_openBlock(), _createBlock(_component_PdfChip, {
                                      key: 1,
                                      color: "blue",
                                      "mangel-amount-mode": "",
                                      value: "1",
                                      "pdf-mode": ""
                                    }))
                                  : _createCommentVNode("", true),
                                ('minus' === grabenquerung['graben-bewertung'])
                                  ? (_openBlock(), _createBlock(_component_PdfChip, {
                                      key: 2,
                                      color: "yellow",
                                      "mangel-amount-mode": "",
                                      value: "1",
                                      "pdf-mode": ""
                                    }))
                                  : _createCommentVNode("", true),
                                ('x' === grabenquerung['graben-bewertung'])
                                  ? (_openBlock(), _createBlock(_component_PdfChip, {
                                      key: 3,
                                      color: "red",
                                      "mangel-amount-mode": "",
                                      value: "1",
                                      "pdf-mode": ""
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_oneto_five_image_div, {
                                ba: null,
                                immobilie: null,
                                fragesPath: "null",
                                lang: _ctx.lang,
                                imageObjects: grabenquerung['graben-bilder'],
                                class: "ml-2 col-span-8"
                              }, null, 8, ["lang", "imageObjects"])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_132, _hoisted_134))
                  ]),
                  _createVNode(_component_Seilzugflaechen_footer, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: ""
                  }, null, 8, ["ba", "immobilie", "lang"])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["pdf-key"]))
        : _createCommentVNode("", true),
      (
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-vorhanden')?.getCurrentInput() ||
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-notwendig')?.getCurrentInput() )
        ? (_openBlock(), _createBlock(_component_pdf_a4_page, {
            key: 3,
            "no-margin": "",
            "pdf-key": _ctx.lang,
            class: "pdf-content"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_135, [
                _createElementVNode("div", _hoisted_136, [
                  _createVNode(_component_tng_header, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createElementVNode("div", _hoisted_137, [
                    _hoisted_138,
                    _createElementVNode("div", _hoisted_139, [
                      _hoisted_140,
                      _hoisted_141,
                      _hoisted_142,
                      _hoisted_143,
                      _createElementVNode("div", _hoisted_144, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.oekologie-group.ampelkarte')?.getSelectedAuswahlLabelsString()), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.oekologie-group.ampelkarte-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _hoisted_145,
                      _createElementVNode("div", _hoisted_146, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.oekologie-group.ffh-gebiet')?.getSelectedAuswahlLabelsString()), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.oekologie-group.ffh-gebiet-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _hoisted_147,
                      _createElementVNode("div", _hoisted_148, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.oekologie-group.biotop')?.getSelectedAuswahlLabelsString()), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.oekologie-group.biotop-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _hoisted_149,
                      _createElementVNode("div", _hoisted_150, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.oekologie-group.vogelschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.oekologie-group.vogelschutzgebiet-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _hoisted_151,
                      _createElementVNode("div", _hoisted_152, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.oekologie-group.wasserschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.oekologie-group.wasserschutzgebiet-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                      _hoisted_153,
                      _createElementVNode("div", _hoisted_154, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.oekologie-group.sonstiges')?.getCurrentInput()), 1),
                      _createVNode(_component_bewertung_chip, {
                        fragenblock: seilzugflaeche,
                        fragesPath: "zuwegung-seilzugflaeche-modal.oekologie-group.sonstiges-bewertung",
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        lang: _ctx.lang,
                        class: "justify-self-end"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                    ]),
                    _hoisted_155,
                    _hoisted_156,
                    _createElementVNode("div", _hoisted_157, [
                      _hoisted_158,
                      _createVNode(_component_oneto_five_image_div_mehrfach, {
                        fragenblock: seilzugflaeche,
                        ba: _ctx.ba,
                        immobilie: _ctx.immobilie,
                        fragesPath: "zuwegung-seilzugflaeche-modal.bilder-group.bilder",
                        lang: _ctx.lang,
                        class: "col-span-8 ml-2"
                      }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                    ]),
                    _hoisted_159
                  ]),
                  _createVNode(_component_Seilzugflaechen_footer, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: ""
                  }, null, 8, ["ba", "immobilie", "lang"])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["pdf-key"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, [
        (seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-vorhanden')?.getCurrentInput() ||
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-notwendig')?.getCurrentInput() )
          ? (_openBlock(), _createBlock(_component_pdf_a4_page, {
              key: 0,
              "no-margin": "",
              "pdf-key": _ctx.lang,
              class: "pdf-content"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_160, [
                  _createElementVNode("div", _hoisted_161, [
                    _createVNode(_component_tng_header, {
                      ba: _ctx.ba,
                      immobilie: _ctx.immobilie,
                      lang: _ctx.lang
                    }, null, 8, ["ba", "immobilie", "lang"]),
                    _hoisted_162,
                    _createElementVNode("div", _hoisted_163, [
                      _createElementVNode("div", _hoisted_164, [
                        _hoisted_165,
                        _hoisted_166,
                        _hoisted_167,
                        _hoisted_168,
                        _hoisted_169,
                        _hoisted_170,
                        _createElementVNode("div", _hoisted_171, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seilzugflaeche.findFrageByRelativePath(_ctx.ba,
                  'seilzugflaeche-modal.allgemein.nutzungsart-der-flaeche'
                )['eingabeMehrfachAuswahlWerts'], (v, key) => {
                            return (_openBlock(), _createElementBlock("ul", {
                              key: key,
                              class: ""
                            }, [
                              (_openBlock(), _createElementBlock("li", {
                                key: key,
                                class: "text-xs text-gray-500"
                              }, _toDisplayString(v), 1))
                            ]))
                          }), 128))
                        ]),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "seilzugflaeche-modal.allgemein.nutzungsart-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_is_vorhanden_char_and_label, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          fragesPath: "seilzugflaeche-modal.allgemein.fremdobjekte-vorhanden",
                          label: "Fremdobjekte auf Fläche",
                          class: "col-span-2"
                        }, null, 8, ["fragenblock", "ba"]),
                        _createElementVNode("div", _hoisted_172, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche')['eingabeText']), 1),
                        _createElementVNode("div", _hoisted_173, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche')['eingabeText']), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_is_vorhanden_char_and_label, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          fragesPath: "seilzugflaeche-modal.allgemein.sonstiges-vorhanden",
                          label: "Sonstiges",
                          class: "col-span-2"
                        }, null, 8, ["fragenblock", "ba"]),
                        _createElementVNode("div", _hoisted_174, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.sonstiges-beschreibung')['eingabeText']), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "seilzugflaeche-modal.allgemein.sonstiges-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end col-span-2"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _hoisted_175,
                        _hoisted_176,
                        _hoisted_177,
                        _createElementVNode("div", _hoisted_178, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.betroffeneflurstuecke').getCurrentInput()?.split(';')?.sort(), (v, key) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: key,
                              class: "text-xs text-gray-500"
                            }, _toDisplayString(v), 1))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode(_component_Seilzugflaechen_footer, {
                      ba: _ctx.ba,
                      immobilie: _ctx.immobilie,
                      lang: _ctx.lang,
                      class: ""
                    }, null, 8, ["ba", "immobilie", "lang"])
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["pdf-key"]))
          : _createCommentVNode("", true),
        (seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-vorhanden')?.getCurrentInput() ||
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-notwendig')?.getCurrentInput() )
          ? (_openBlock(), _createBlock(_component_pdf_a_4_page, {
              key: 1,
              "no-margin": "",
              "pdf-key": _ctx.lang,
              class: "pdf-content"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_179, [
                  _createElementVNode("div", _hoisted_180, [
                    _createVNode(_component_tng_header, {
                      ba: _ctx.ba,
                      immobilie: _ctx.immobilie,
                      lang: _ctx.lang
                    }, null, 8, ["ba", "immobilie", "lang"]),
                    _createElementVNode("div", _hoisted_181, [
                      _hoisted_182,
                      _createElementVNode("div", _hoisted_183, [
                        _hoisted_184,
                        _hoisted_185,
                        _hoisted_186,
                        _hoisted_187,
                        _createVNode(_component_is_vorhanden_char_and_label, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-erforderlich",
                          label: "Ausholzung erforderlich",
                          class: "col-span-2"
                        }, null, 8, ["fragenblock", "ba"]),
                        _createElementVNode("div", _hoisted_188, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-art')?.getSelectedAuswahlLabelsString()), 1),
                        _createElementVNode("div", _hoisted_189, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-beschreibung')['eingabeText']), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_oneto_five_image_div_mehrfach, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-bilder",
                          lang: _ctx.lang,
                          class: "col-span-8 ml-2"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_is_vorhanden_char_and_label, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-erforderlich",
                          label: "Rodung erforderlich",
                          class: "col-span-2"
                        }, null, 8, ["fragenblock", "ba"]),
                        _createElementVNode("div", _hoisted_190, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-anzahl-baeume')['eingabeText']), 1),
                        _createElementVNode("div", _hoisted_191, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-beschreibung')['eingabeText']), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_oneto_five_image_div_mehrfach, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          fragesPath: "",
                          lang: _ctx.lang,
                          class: "col-span-8 ml-2"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_is_vorhanden_char_and_label, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.graben-vorhanden",
                          label: "Feuchtgebiete vorhanden",
                          class: "col-span-2"
                        }, null, 8, ["fragenblock", "ba"]),
                        _createElementVNode("div", _hoisted_192, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-beschreibung')['eingabeText']), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_oneto_five_image_div_mehrfach, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bilder",
                          lang: _ctx.lang,
                          class: "col-span-8 ml-2"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_is_vorhanden_char_and_label, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-vorhanden",
                          label: "Naturdenkmäler vorhanden",
                          class: "col-span-2"
                        }, null, 8, ["fragenblock", "ba"]),
                        _createElementVNode("div", _hoisted_193, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-beschreibung')['eingabeText']), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_oneto_five_image_div_mehrfach, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          fragesPath: "",
                          lang: _ctx.lang,
                          class: "col-span-8 ml-2"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_is_vorhanden_char_and_label, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-vorhanden",
                          label: "Kampfmittel vorhanden",
                          class: "col-span-2"
                        }, null, 8, ["fragenblock", "ba"]),
                        _createElementVNode("div", _hoisted_194, [
                          (seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-freimessung')?.getCurrentInput())
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" Freimessung erforderlich ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" Freimessung nicht erforderlich ")
                              ], 64))
                        ]),
                        _createElementVNode("div", _hoisted_195, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-art')['eingabeText']), 1),
                        _createElementVNode("div", _hoisted_196, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-beschreibung')['eingabeText']), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_oneto_five_image_div_mehrfach, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          fragesPath: "",
                          lang: _ctx.lang,
                          class: "col-span-8 ml-2"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_is_vorhanden_char_and_label, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-vorhanden",
                          label: "Sonstiges vorhanden",
                          class: "col-span-2"
                        }, null, 8, ["fragenblock", "ba"]),
                        _createElementVNode("div", _hoisted_197, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-beschreibung')['eingabeText']), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _createVNode(_component_oneto_five_image_div_mehrfach, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-bilder",
                          lang: _ctx.lang,
                          class: "col-span-8 ml-2"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                      ])
                    ]),
                    _createVNode(_component_Seilzugflaechen_footer, {
                      ba: _ctx.ba,
                      immobilie: _ctx.immobilie,
                      lang: _ctx.lang,
                      class: ""
                    }, null, 8, ["ba", "immobilie", "lang"])
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["pdf-key"]))
          : _createCommentVNode("", true),
        (
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-vorhanden')?.getCurrentInput() ||
      seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-notwendig')?.getCurrentInput() )
          ? (_openBlock(), _createBlock(_component_pdf_a_4_page, {
              key: 2,
              "no-margin": "",
              "pdf-key": _ctx.lang,
              class: "pdf-content"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_198, [
                  _createElementVNode("div", _hoisted_199, [
                    _createVNode(_component_tng_header, {
                      ba: _ctx.ba,
                      immobilie: _ctx.immobilie,
                      lang: _ctx.lang
                    }, null, 8, ["ba", "immobilie", "lang"]),
                    _createElementVNode("div", _hoisted_200, [
                      _hoisted_201,
                      _createElementVNode("div", _hoisted_202, [
                        _hoisted_203,
                        _hoisted_204,
                        _hoisted_205,
                        _hoisted_206,
                        _createElementVNode("div", _hoisted_207, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.ampelkarte')?.getSelectedAuswahlLabelsString()), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.ampelkarte-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _hoisted_208,
                        _createElementVNode("div", _hoisted_209, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.ffh-gebiet')?.getSelectedAuswahlLabelsString()), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.ffh-gebiet-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _hoisted_210,
                        _createElementVNode("div", _hoisted_211, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.biotop')?.getSelectedAuswahlLabelsString()), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.biotop-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _hoisted_212,
                        _createElementVNode("div", _hoisted_213, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.vogelschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.vogelschutzgebiet-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _hoisted_214,
                        _createElementVNode("div", _hoisted_215, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.wasserschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.wasserschutzgebiet-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                        _hoisted_216,
                        _createElementVNode("div", _hoisted_217, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.sonstiges')?.getCurrentInput()), 1),
                        _createVNode(_component_bewertung_chip, {
                          fragenblock: seilzugflaeche,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group.sonstiges-bewertung",
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          lang: _ctx.lang,
                          class: "justify-self-end"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                      ]),
                      _hoisted_218,
                      _hoisted_219,
                      _createElementVNode("div", _hoisted_220, [
                        _hoisted_221,
                        _createVNode(_component_oneto_five_image_div_mehrfach, {
                          fragenblock: seilzugflaeche,
                          ba: _ctx.ba,
                          immobilie: _ctx.immobilie,
                          fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.bilder-group.bilder",
                          lang: _ctx.lang,
                          class: "col-span-8 ml-2"
                        }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                      ]),
                      _hoisted_222
                    ]),
                    _createVNode(_component_Seilzugflaechen_footer, {
                      ba: _ctx.ba,
                      immobilie: _ctx.immobilie,
                      lang: _ctx.lang,
                      class: ""
                    }, null, 8, ["ba", "immobilie", "lang"])
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["pdf-key"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seilzugflaeche['grabenquerungenPages'], (grabenquerungenPage, gqPageKey) => {
          return (_openBlock(), _createBlock(_component_pdf_a4_page, {
            "no-margin": "",
            "pdf-key": _ctx.lang,
            class: "pdf-content",
            key: gqPageKey
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_223, [
                _createElementVNode("div", _hoisted_224, [
                  _createVNode(_component_tng_header, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createElementVNode("div", _hoisted_225, "Grabenquerungen (" + _toDisplayString(gqPageKey + 1) + ") von Seilzugfläche " + _toDisplayString(szfKey + 1), 1),
                  _createElementVNode("div", _hoisted_226, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grabenquerungenPage['grabenquerungen'], (grabenquerung, gqKey) => {
                      return (_openBlock(), _createElementBlock("div", { key: gqKey }, [
                        _createElementVNode("div", _hoisted_227, "Grabenquerung " + _toDisplayString((gqPageKey)*2 + gqKey+1), 1),
                        _createTextVNode(" Grabenquerung erforderlich: " + _toDisplayString(grabenquerung['erforderlich']) + " Anzahl: " + _toDisplayString(grabenquerung['anzahl']) + " Graben Beschreibung: " + _toDisplayString(grabenquerung['beschreibung']) + " Bewertung Graben: " + _toDisplayString(grabenquerung['bewertung']) + " ", 1),
                        _createVNode(_component_UniversalPdfImageRow, {
                          "image-objects": grabenquerung['bilder']
                        }, null, 8, ["image-objects"]),
                        ('plus' === grabenquerung['bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 0,
                              color: "green",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        ('o' === grabenquerung['bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 1,
                              color: "blue",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        ('minus' === grabenquerung['bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 2,
                              color: "yellow",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        ('x' === grabenquerung['bewertung'])
                          ? (_openBlock(), _createBlock(_component_PdfChip, {
                              key: 3,
                              color: "red",
                              "mangel-amount-mode": "",
                              value: "1",
                              "pdf-mode": ""
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_228
                      ]))
                    }), 128))
                  ]),
                  _createVNode(_component_Seilzugflaechen_footer, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: ""
                  }, null, 8, ["ba", "immobilie", "lang"])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["pdf-key"]))
        }), 128))
      ])
    ]))
  }), 128))
}